import { InputShape, InputSize, InputTheme } from 'components/common/types/Input.types';
import AsyncSelect from 'lib/AsyncSelect';
import { ShadowStyle } from 'consts/shadow';
import { OptionType, Padding } from 'lib/BaseSelect/BaseSelect.types';
import { FilterPlannerProductCategoryProps } from './FilterPlannerProductCategory.types';
import { useLoadLookup } from '../useLoadLookup';

const FilterPlannerProductCategory = ({
  dataTestId,
  dataPendoId,
  isDisabled,
  options,
  selectedValue,
  onSelect,
  placeholder = '',
}: FilterPlannerProductCategoryProps): React.ReactElement => {
  const { onLoadProductCategory } = useLoadLookup();

  return (
    <AsyncSelect
      name="productCategory"
      dataTestId={dataTestId}
      dataPendoId={dataPendoId}
      placeholder={placeholder}
      theme={InputTheme.WHITE_WITH_BORDER}
      size={InputSize.EXTRA_SMALL}
      padding={Padding.NONE}
      shadow={ShadowStyle.NONE}
      shape={InputShape.ROUNDED}
      selectedValue={selectedValue}
      loadData={onLoadProductCategory}
      onSelect={onSelect}
      defaultOptions={options as OptionType[]}
      isDisabled={isDisabled}
    />
  );
};

export default FilterPlannerProductCategory;
